import { useParams } from "react-router-dom";
import { get_averias } from "../../../redux/actions/averias/averias";
import { PDFViewer } from "@react-pdf/renderer";
import { connect } from "react-redux";
import { useEffect } from "react";
import MyDocument from "../../../components/pdf/P03/averias/Averias";
import DashboardLayout from "../../../hocs/layout/DashboardLayout";

function AveriasReportePdf({ get_averias, averias }) {
  const params = useParams();
  const uid = params.uid;

  useEffect(() => {
    get_averias(uid);
  }, [uid]);
  return (
    <DashboardLayout>
      <div className="border-b border-gray-200 py-5 sm:px-6">
        <div className="flex flex-col flex-wrap lg:flex-row lg:items-center justify-between sm:flex-nowrap">
          <div className="">
            <h3 className="text-2xl font-medium leading-6 text-gray-900 dark:text-white">
              Reporte de Averias Planta 03.
            </h3>
          </div>
        </div>
        <div className="mt-10 flex flex-col lg:flex-row lg:items-center gap-4 py-2 lg:py-0">
          {averias ? (
            <div className="w-full">
              <PDFViewer className="w-full h-[75vh] md:h-[85vh]">
                <MyDocument data={averias} />
              </PDFViewer>
            </div>
          ) : (
            <div className="flex items-center justify-center h-96">
              <div className="w-10 h-10 border-t-2 border-b-2 border-[#0096C4] rounded-full animate-spin"></div>
            </div>
          )}
        </div>
      </div>
    </DashboardLayout>
  );
}

const mapStateToProps = (state) => ({
  averias: state.averias.averias,
});

export default connect(mapStateToProps, { get_averias })(AveriasReportePdf);
